import { render, staticRenderFns } from "./orderIncludeDetail.vue?vue&type=template&id=1e120072&scoped=true&"
import script from "./orderIncludeDetail.vue?vue&type=script&lang=js&"
export * from "./orderIncludeDetail.vue?vue&type=script&lang=js&"
import style0 from "./orderIncludeDetail.vue?vue&type=style&index=0&id=1e120072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e120072",
  null
  
)

export default component.exports